<div class="row" *ngFor="let car of day?.cars[0]?.vehicles">
  <div class="col-12 pl-4 pt-2">
    <span class="overview-icons"> <app-service-icon [icon]="'car-side'" [customPath]="getServiceIconPath('car-side')"></app-service-icon> </span>
    <span class="text-capitalize">{{ getCarRecap(car) }}</span>
  </div>
</div>
